module.exports = __webpack_public_path__ + "media/icons/warning-ca7f715a2ad0247d845101eb4b8260cd.svg";